
import { mapGetters } from 'vuex'
import DaisoImage from '~/components/common/DaisoImage.vue'
export default {
  name: 'LoadingBar',
  components: { DaisoImage },
  computed: {
    ...mapGetters('loading', ['isLoading'])
  },
  // props: {
  //   showLoadingBar: { type: Boolean, default: false }
  // }
}
